import { datasource } from './datasource';

export const customerDS = (databaseAlias, currentUserId, actions) => () =>
  datasource(databaseAlias, currentUserId, actions)('customer', {
    model: {
      id: 'id',
      auditable: true,
      syncable: true,
      autoSync: true,
      byProshop: true,
      byProshopSQL:
        'SELECT t1.*, (SELECT COUNT(*) FROM spec_sheet as t3 WHERE t1.id=t3.customer_id) as total_spec_sheets, (SELECT COUNT(*) FROM ball_drilled as t4 WHERE t1.id=t4.customer_id)  as total_balls FROM -tablename- AS t1, customer_proshop AS t2 WHERE t1.id = t2.customer_id AND t2.proshop_id = "-proshopId-"',
      // byProshopSQL:
      //   'SELECT t1.* FROM -tablename- AS t1, customer_proshop AS t2 WHERE t1.id = t2.customer_id ',
      fields: {
        id: {
          type: 'string',
        },
        firstname: {
          type: 'string',
        },
        lastname: {
          type: 'string',
        },
        email: {
          type: 'string',
        },
        password: {
          type: 'number',
        },
        telephone: {
          type: 'string',
        },
        hand: {
          type: 'string',
          alter: true,
        },
        style: {
          type: 'string',
          alter: true,
        },
        address: {
          type: 'string',
        },
        country: {
          type: 'string',
        },
        state: {
          type: 'number',
        },
        city: {
          type: 'string',
        },
        postal_code: {
          type: 'string',
        },
        preferred_lang: {
          type: 'string',
        },
        photo: {
          type: 'raw',
        },
        pap_h: {
          type: 'string',
        },
        pap_v: {
          type: 'string',
        },
        pap_ud: {
          type: 'string',
        },
        axis_rot: {
          type: 'string',
        },
        axis_tilt: {
          type: 'string',
        },
        ball_speed: {
          type: 'string',
        },
        rev_rate: {
          type: 'string',
        },
        signature: {
          type: 'string',
          alter: true,
        },
        created_at: {
          type: 'string',
        },
        updated_at: {
          type: 'string',
        },
        created_by: {
          type: 'string',
        },
        updated_by: {
          type: 'string',
        },
        total_spec_sheets: {
          type: 'number',
          selectOnly: true,
        },
        total_balls: {
          type: 'number',
          selectOnly: true,
        },
      },
    },
  });
